var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"10","width":"10","viewBox":"0 0 10 10"}},[_c('polygon',{staticStyle:{"fill":"#85E04A","stroke":"#85E04A","stroke-width":"1"},attrs:{"points":"0,10 5,0 10,10"}})])}
var staticRenderFns = []

export { render, staticRenderFns }